<template>
  <div id="slide-settings">
    <Panel title="GROUPS">
      <ListMultiForm
        v-model="groups"
        :form-component="slideGroupComponent"
        :data-on-add="() => ({id: null, title: {}, description: {}})"
        title="GROUPS"
        no-selection-text="--- Select slide groups to modify ---"
        label-key="title"
      />
      {{groups}}
    </Panel>
  </div>
</template>

<script>
import {Core} from "@/core/Core";
import ListMultiForm from "@/components/qsr/ListMultiForm";
import SlideGroup from "@/components/slide/SlideGroup";

export default {
  name: "SlideSettings",
  components: {ListMultiForm},

  data() {
    return {
      groups: []
    }
  },

  computed: {
    slideGroupComponent() {
      return SlideGroup;
    }
  },

  async mounted() {
    let response = await Core.request('GET', '/api/slide_groups');
    if (response) {
      this.groups = response.data;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>